<div class="modal-content">
  <h2 class="mat-h2">Download HCPs</h2>
  <form [formGroup]="downloadSettingsForm" class="flex flex-col gap-4">
    <!-- Geography selector -->
    <app-region-select
      [regions]="regions"
      [regionsFiltered]="regionsFiltered"
      [selectedRegions]="geography"
      [multiple]="false"
    ></app-region-select>
    <mat-error
      *ngIf="geography.invalid && (geography.dirty || geography.touched)"
    >
      Geography is required
    </mat-error>

    <!-- Network checkbox -->
    <mat-checkbox formControlName="withNetwork">
      Download network
    </mat-checkbox>
  </form>

  <div mat-dialog-actions class="flex justify-between items-end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="downloadSettingsForm.invalid"
    >
      Download
    </button>
  </div>
</div>
